// Re-export shim for the api-backed inviteService.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) =>
  typeof value === 'string' && EMAIL_RE.test(value.trim());

export const parseEmailList = (raw) => {
  if (typeof raw !== 'string' || !raw.trim()) return { valid: [], invalid: [] };
  const seen = new Set();
  const valid = [];
  const invalid = [];
  const tokens = raw
    .split(/[,;\n\r\t]+/)
    .map((s) => s.trim())
    .filter(Boolean);
  for (const tok of tokens) {
    const lower = tok.toLowerCase();
    if (seen.has(lower)) continue;
    seen.add(lower);
    if (isValidEmail(tok)) valid.push(lower);
    else invalid.push(tok);
  }
  return { valid, invalid };
};

export { inviteService } from './inviteServiceV2';
export { default } from './inviteServiceV2';
